import React from "react";
import { Box, Dialog, DialogContent, IconButton } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import CustomButton from "../CustomButton";
import { COLORS } from "../../assets/theme";
import FeatureLockedContent from "./FeatureLockedContent";

interface FeatureLockedDialogProps {
  open: boolean;
  /** The feature key, e.g. "CLASSES". */
  feature: string | null;
  onClose: () => void;
}

/** Shown instead of navigating when a locked sidebar entry is tapped. */
const FeatureLockedDialog: React.FC<FeatureLockedDialogProps> = ({
  open,
  feature,
  onClose,
}) => (
  <Dialog
    open={open && !!feature}
    onClose={onClose}
    maxWidth="xs"
    fullWidth
    PaperProps={{ sx: { borderRadius: 3 } }}
  >
    <DialogContent sx={{ p: 3 }}>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: -4 }}>
        <IconButton aria-label="Close" onClick={onClose} sx={{ mt: -1, mr: -1 }}>
          <CloseRoundedIcon />
        </IconButton>
      </Box>

      {feature && <FeatureLockedContent feature={feature} />}

      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2.5 }}>
        <CustomButton
          label="Got it"
          onClick={onClose}
          variant="contained"
          bgColor={COLORS.MainColor}
          textColor={COLORS.WhiteText}
        />
      </Box>
    </DialogContent>
  </Dialog>
);

export default FeatureLockedDialog;
